<div class="content-top-bar">
  <div class="left-pane">
    @if (showLeftMenuOpener()) {
      <div class="margin-right">
        <button
          class="sidebar-toggle-btn"
          alg-button-icon
          type="button"
          icon="ph ph-list"
          aria-label="Open sidebar"
          i18n-aria-label
          algTooltip="Open sidebar"
          i18n-algTooltip
          tooltipPosition="right"
          (click)="showLeftMenu()"
        ></button>
      </div>
    }
    @if (displayScoreSection() && !showPlatformLogo()) {
      <div class="margin-right score-section">
        @if (score(); as scoreVal) {
          <alg-score-ring [bestScore]="scoreVal.best"
            [currentScore]="scoreVal.current"
            [isValidated]="scoreVal.validated"
            [diameter]="32"
           />
        }
      </div>
    }
    <ng-container *ngrxLet="{
      fullFrameContentDisplayed: fullFrameContentDisplayed$,
      shouldDisplayTabBar: shouldDisplayTabBar$,
      isNarrowScreen: isNarrowScreen$,
      hideHeader: hideHeader$,
    } as behaviourInfo">
      @if ((!behaviourInfo.isNarrowScreen || behaviourInfo.isNarrowScreen && !behaviourInfo.fullFrameContentDisplayed) && isTitleSectionReady()) {
        <div
          class="left-pane-title margin-right"
          [class.left-pane-title--stretch]="showBreadcrumbs() && !showPlatformLogo()"
        >
          @if (showPlatformLogo()) {
            <alg-platform-logo />
          } @else {
            @let titleVal = title();
            @if (!showBreadcrumbs() && titleVal) {
              <p class="left-pane-title-text">{{ titleVal }}</p>
            } @else {
              <alg-breadcrumbs class="breadcrumbs" />
            }
          }
        </div>
      }
      <!-- Tab bar in top bar: mirror of item-by-id tab bar; keep conditions mutually exclusive. -->
      @if (behaviourInfo.shouldDisplayTabBar && (behaviourInfo.fullFrameContentDisplayed || behaviourInfo.hideHeader)) {
        <alg-tab-bar class="tab-bar"
          styleClass="for-header"
         />
      }
    </ng-container>
  </div>
  <div class="right-pane">
    <alg-time-limited-content-info />
    <alg-observation-bar />
    @if (navigationNeighbors$ | async; as navigationNeighbors) {
      <alg-neighbor-widget class="neighbor-widget margin-left"
        [navigationMode]="{
          parent: !!navigationNeighbors?.isReady && !!navigationNeighbors?.data?.parent,
          left: !!navigationNeighbors?.isReady && !!navigationNeighbors?.data?.previous,
          right: !!navigationNeighbors?.isReady && !!navigationNeighbors?.data?.next
        }"
        (parent)="navigationNeighbors?.data?.parent?.navigateTo()"
        (left)="navigationNeighbors?.data?.previous?.navigateTo()"
        (right)="navigationNeighbors?.data?.next?.navigateTo()"
       />
    }
  </div>
</div>
